import { GET_TABLE_FILTERS } from './getTableFilters';
import { GET_FILTER_OPTIONS } from './getFilterOptions';
import { GET_FILTERS_OPTIONS } from './getFiltersOptions';
import { GET_VENDOR_OPPORTUNITIES_LIST } from './getVendorOpportunitiesList';
import { GET_VENDOR_OPPORTUNITIES_LIST_PARTNER } from './getVendorOpportunitiesListPartner';

import { CREATE_TABLE_FILTER } from './createTableFilter';
import { UPDATE_TABLE_FILTER } from './updateTableFilter';
import { DELETE_TABLE_FILTER } from './deleteTableFilter';
import { TOGGLE_DEFAULT_TABLE_FILTER } from './toggleDefaultTableFilter';

import { CHECK_IS_BPFS_EXIST_FOR_ACCOUNT } from './getBusinessProcessFlowTemplates';
import { UPDATE_ROW_DISPLAY_STATUS } from './updateRowDisplayStatus';

export const opportunitiesListApi = {
  getTableFilters: GET_TABLE_FILTERS,
  getFilterOptions: GET_FILTER_OPTIONS,
  getVendorOpportunitiesList: GET_VENDOR_OPPORTUNITIES_LIST,
  getVendorOpportunitiesListPartner: GET_VENDOR_OPPORTUNITIES_LIST_PARTNER,
  getFiltersOptions: GET_FILTERS_OPTIONS,

  deleteFilter: DELETE_TABLE_FILTER,
  createFilter: CREATE_TABLE_FILTER,
  updateFilter: UPDATE_TABLE_FILTER,
  toggleDefaultTableFilter: TOGGLE_DEFAULT_TABLE_FILTER,

  getBusinessProcessFlowTemplates: CHECK_IS_BPFS_EXIST_FOR_ACCOUNT,
  updateRowDisplayStatus: UPDATE_ROW_DISPLAY_STATUS,
};

export * from './usePresets';
export * from './useFilterOptions';
